module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAOFJREFUKBWlkk0OgjAQhZE0hB1Lb+Ah9A4uTDyUC65gvJaENRvKb4GFtKnzjE1KglhxkqbTme+9tJNuOOf3KIp2jDHvn5BSek3TJH4QBPu6roXWerUftPCA18ukbdtjVVUPaqwKaOExuREVr33f/2wIDbQTM3PI8zwZx9HZFCw0Ro/dtw9hGB4wC7u2lIOFZonxhBAnesLXa4IBu2hmmgTfhmH4+HT0wBjeaafZpHPzfM8tdTKxoa7rtmSK/zkJ1NCzWeechn4uikIqpTQWctScDebAsiwvWZYpLJpbPMfYtSch15A9CzJnigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/shopping_cart_tips_triangle.png
// module id = 894
// module chunks = 126